import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Crown = t0 => {
  const $ = _c(5);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M5.56517 7.12553L6.06953 6.16554L6.88152 7.0525M10.5262 7.12553L10.049 6.11262L9.1479 7.15517M4.45643 10.2468H11.5436M11.3697 11.5L12.3882 6.63124C12.5354 6.56886 12.6649 6.47292 12.7659 6.35152C12.867 6.23011 12.9365 6.08682 12.9687 5.93374C13.0991 5.38971 12.81 4.83192 12.3241 4.68586C11.8382 4.5398 11.3371 4.8605 11.2067 5.40453C11.1685 5.56289 11.1659 5.72739 11.1989 5.88683C11.2319 6.04628 11.2998 6.19693 11.398 6.32854L9.58922 8.1776L8.5131 5.86071C8.64103 5.75814 8.74339 5.62864 8.81249 5.48198C8.88159 5.33531 8.91562 5.1753 8.91203 5.01397C8.91203 4.45618 8.50332 4 8.00004 4C7.49676 4 7.08805 4.45618 7.08805 5.0182C7.08445 5.17953 7.11848 5.33955 7.18758 5.48621C7.25668 5.63288 7.35905 5.76237 7.48697 5.86495L6.41085 8.18184L4.60209 6.32854C4.70087 6.19642 4.76911 6.04504 4.80214 5.88482C4.83516 5.72459 4.83218 5.5593 4.7934 5.4003C4.66296 4.85627 4.16294 4.5345 3.67597 4.67951C3.18899 4.82451 2.90094 5.3876 3.03138 5.93163C3.06339 6.08477 3.13287 6.22814 3.23391 6.34957C3.33496 6.47099 3.4646 6.56689 3.61183 6.62913L4.63035 11.4979H11.3697V11.5Z" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== props) {
    t2 = <IconWrapper {...props} variant="outline" viewBox="0 0 16 16">{t1}</IconWrapper>;
    $[3] = props;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
export { Crown };